import { ArrowRight } from "lucide-react";

import { BadgeStatus } from "@/components/ui/badge-status";

/**
 * „Show, don't tell" teaser u praznom stanju — pokazuje OBLIK odgovora prije
 * nego korisnik pita (uzorak s Landinga): oznaka + limit → verdikt + citat.
 * Statičan; interaktivni dio su primjeri-pitanja iznad.
 */
export function ExampleTeaser() {
  return (
    <div className="mt-3 flex flex-wrap items-center gap-2 rounded-md border border-stone-200 bg-white/70 px-3 py-2 text-[0.8rem]">
      <span className="text-[0.62rem] font-bold uppercase tracking-[0.1em] text-stone-400">
        Primjer
      </span>
      <span className="font-mono text-stone-700">M1 · KIG 0,4</span>
      <ArrowRight className="h-3.5 w-3.5 text-stone-400" />
      <BadgeStatus kind="warn">Dopušteno uz uvjete</BadgeStatus>
      <span className="text-stone-400">limiti plana · čl. 64</span>
    </div>
  );
}
